import { render, staticRenderFns } from "./KpiSettingEdit.vue?vue&type=template&id=10b4b054"
import script from "./KpiSettingEdit.vue?vue&type=script&lang=js"
export * from "./KpiSettingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports